import styled from "@emotion/styled";

import { Typography } from "@mui/material";
import useAppSelector from "../../../hooks/useAppSelector";
import { RootState } from "../../../redux/store";
import { ViewFile } from "../../../utils/fnsRedux";
import ConfidenceChip from "../ConfidenceChip";

const Main = styled.div`
  width: 650px;
  height: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Result = styled.div`
  padding: 5px 10px 10px 10px;
  margin-left: 5px;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.sidebar.color};
  }
`;

function TreemapList() {
  const searchState = useAppSelector((state: RootState) => state.search);
  const currSelected = searchState.treemapGroups;
  const onClick = ViewFile();
  const resultsToDisplay =
    currSelected === null || Object.keys(currSelected).length === 0
      ? searchState.queryResult
      : currSelected.groups
      ? searchState.queryResult.filter(
          (query) => parseInt(currSelected.id) === query.cluster
        )
      : searchState.queryResult.filter(
          (query) => query.answer === currSelected.label
        );

  return (
    <Main>
      {resultsToDisplay.map((result, idx) => {
        return (
          <Result
            key={idx}
            onClick={() =>
              onClick(result.description, result.pdfName, result.page)
            }
          >
            <Typography fontWeight="bold" sx={{ marginBottom: "4px" }}>
              {result.answer}
            </Typography>
            <ConfidenceChip score={result.score} />
            <Typography sx={{ marginTop: "4px" }}>
              {result.description
                .slice(
                  Math.max(0, result.description.length / 2),
                  result.description.length / 2 + 9
                )
                .join(" ")}
            </Typography>
          </Result>
        );
      })}
    </Main>
  );
}

export default TreemapList;
